<script>
	import { currency_formatter } from '../globals.js';
	import Header from '../components/Header.svelte';
	import { navigate } from 'svelte-routing';
	import Responsivetable from '../utils/responsivetable.svelte';
	import { onMount } from 'svelte';
	import { init_data } from '../init.js';
	import { api_host, all_jobs_store, user_store, company_details_store } from '../stores.js';
	import { formatDate, get_job_status, formatter } from '../utils/format.js';
	import { getToken, doFetch } from "../utils/Fetching.js";
	import { toast_message } from '../utils/toast_message.js';
	import Swal from "sweetalert2";
	import { state_codes } from '../globals.js';

	const { auth_type, auth_token, domain_code } = getToken();

	let from_date = undefined;
	let to_date = undefined;
	let jobs = [];
	let myself = {};
	let is_mounted = false;

	let google;
	let map;
	let markers = [];
	let infowindows = [];
	let marker_visible_ids = [];
	let center = { lat: 0, lng: 0 };
	let company_details = {};
	let company_location = null;
	let directionsService;
	let directionsRenderer;

	const numFormatter = new Intl.NumberFormat('en-US');
	onMount(() => {
		init_data('all');
	});

	let table_header_config = [
		{'t': 'Address', 'fm': 'a', 'a': true},
		{'t': 'City', 'fm': 'c', 'a': true},
		{'t': 'Date / Time', 'fm': 'dt', 'a': true},
		{'t': 'Service Frequency', 'fm': 'sf', 'a': false},
		{'t': 'Lawn Type', 'fm': 'lt', 'a': false},
		{'t': 'Service Type', 'fm': 'st', 'a': false},
	];

	let statistic_data = {};

	user_store.subscribe(value => {
		myself = value;
		let updated_table_header;
		if (myself.user.role === 'client') {
			updated_table_header = [
				{'t': 'Email', 'fm': 'e', 'a': false},
				{'t': 'Home Phone', 'fm': 'hp', 'a': false},
				{'t': 'Cell Phone', 'fm': 'cp', 'a': false},
			].concat(table_header_config);
			updated_table_header = updated_table_header.concat([
				{'t': 'Price', 'fm': 'p', 'a': true},
				{'t': 'Status', 'fm': 's', 'a': true},
				{'t': 'Payment Type', 'fm': 'pt', 'a': false},
				{'t': 'Action', 'fm': 'pay_now', 'a': true},
			]);
		} else {
			updated_table_header = [{'t': 'Map', 'fm': 'map', 'a': true}];
			if (myself.user.role === 'contractor') {
				updated_table_header = updated_table_header.concat(table_header_config);
				updated_table_header = updated_table_header.concat([
					{'t': 'Price', 'fm': 'contractor_price', 'a': true}
				]);
			} else {
				updated_table_header = updated_table_header.concat([
					{'t': 'Email', 'fm': 'e', 'a': false},
					{'t': 'Home Phone', 'fm': 'hp', 'a': false},
					{'t': 'Cell Phone', 'fm': 'cp', 'a': false},
				]);
				updated_table_header = updated_table_header.concat(table_header_config);
				updated_table_header = updated_table_header.concat([
					{'t': 'Hours', 'fm': 'hours', a: true}
				]);
			}
			updated_table_header = updated_table_header.concat([
				{'t': 'Status', 'fm': 's', 'a': true}
			]);
		}
		table_header_config = updated_table_header;
	});

	company_details_store.subscribe(value => {
			console.log('company_details', value);
			company_details = value;        
	});

	const visible_markers = (filtered) => {
			// close all info windows
			infowindows.forEach(_w => _w.close());

			for (let i = 0; i < marker_visible_ids.length; i++) {
					const jid = marker_visible_ids[i];
					let marker = markers.find(m => m[2] === jid);            
					if (!marker) {
							const job = jobs.find(_j => _j.id === jid);
							const label = job.name;
							const latlng = new google.maps.LatLng(job.lat, job.lng);
							const infowindow = new google.maps.InfoWindow({
									content: `<div class="info-window">
											<div>${job.a}</div>
									</div>`,
									ariaLabel: "Uluru",
							});
							const marker = new google.maps.Marker({
									position: latlng,
									map: map,
									animation: google.maps.Animation.DROP,
									// label: label
							});
							marker.addListener("click", () => {
									infowindow.open({
											anchor: marker,
											map,
									});
							});
							marker.setVisible(false);
							markers.push([marker, job.service_date, job.id]);
							infowindows.push(infowindow);
					}
			}

			if (filtered === true) {
				for (let i = 0; i < markers.length; i ++) {
					if (from_date <= markers[i][1] && markers[i][1] <= to_date) {
						if (marker_visible_ids.includes(markers[i][2])) markers[i][0].setVisible(true);
						else markers[i][0].setVisible(false);
					} else {
						markers[i][0].setVisible(false);
					}
				}
			} else {
				for (let i = 0; i < markers.length; i ++) {
					if (marker_visible_ids.includes(markers[i][2])) {
						markers[i][0].setVisible(true);
					} else {
						markers[i][0].setVisible(false);
					}
				}
			}
	};

	function showDefaultMap() {
		if (company_location?.lat) {
				map.setCenter(company_location);
				map.setZoom(7);
		} else {
				map.setZoom(1);
		}
	}
	$: {
		if (is_mounted && jobs.length > 0 && company_location === null && myself.user && (myself.user.role === 'contractor' || myself.user.role === 'employee')) {
			if (!markers.length) {
				if (!map) {
						google = window.google;
						map = document.getElementById("map-canvas");
						console.log('map tag', map);

						center = { lat: 34.483635, lng: -111.669098 };
						const mapOptions = {
								zoom: 1,
								scrollwheel: false,
								center: center,
								mapTypeId: google.maps.MapTypeId.ROADMAP,
						};

						if (map) {
							map = new google.maps.Map(map, mapOptions);
							directionsService = new google.maps.DirectionsService();
							directionsRenderer = new google.maps.DirectionsRenderer({suppressMarkers: true});
							directionsRenderer.setMap(map);
						}
				}

				if (map) {
					const geocoder = new google.maps.Geocoder();
					const address = `${company_details.address}, ${company_details.city}, ${company_details.state}`;
					console.log('address', address);
					geocoder.geocode({ 'address': address }, function(results, status) {
							if (status === 'OK') {
									company_location = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
									console.log('company location', company_location);
									showDefaultMap();
							}
					});
				}
			} else {

				visible_markers(false);
			}
		}
	}

	window.clear_map = (event) => {
			const elements = document.getElementsByClassName('map-checkbox');
			for (let i = 0; i < elements.length; i++) {
					if (elements[i].checked) elements[i].checked = false;
			}
			marker_visible_ids = [];
			visible_markers(false);
			directionsRenderer.setDirections({ routes: [] });
			showDefaultMap();
			event.preventDefault();
	}
	
	window.select_map = (event) => {
		console.log('select_map', event);
		const jid = parseInt(event.target.value);
		if (event.target.checked === true) {
				const job = jobs.find(_j => _j.id === jid);
				if (job.lat !== undefined && job.lng !== undefined && job.lat !== 200 && job.lng !== 200) {
			    marker_visible_ids.push(jid);
        }
		} else {
			marker_visible_ids = marker_visible_ids.filter(_jid => _jid !== jid);
		}

		// if (from_date && to_date) {
		// 	visible_markers(true);
		// } else {
		// 	visible_markers(false);
		// }
		visible_markers(false);
		console.log('visible markers', marker_visible_ids);

		directionsRenderer.setDirections({ routes: [] });
		if (marker_visible_ids.length === 0) {
				showDefaultMap();
				return;
		}

		if (marker_visible_ids.length === 1) {
				const job = jobs.find(_j => _j.id === marker_visible_ids[0]);
				map.setCenter({ lat: job.lat, lng: job.lng });
				map.setZoom(15);
		} else {
				const bounds = new google.maps.LatLngBounds();
				const locations = [];
				marker_visible_ids.forEach(jid => {
						const job = jobs.find(_j => _j.id === jid);
						bounds.extend({ lat: job.lat, lng: job.lng });
						locations.push({ lat: job.lat, lng: job.lng });
				});
				map.fitBounds(bounds);

				// draw route
				const waypoints = locations.slice(1, locations.length - 1).map(location => ({
						location: new google.maps.LatLng(location.lat, location.lng),
						stopover: true
				}));

				directionsService.route(
						{
								origin: new google.maps.LatLng(locations[0].lat, locations[0].lng),
								destination: new google.maps.LatLng(locations[locations.length - 1].lat, locations[locations.length - 1].lng),
								waypoints: waypoints,
								optimizeWaypoints: true,
								travelMode: google.maps.TravelMode.DRIVING
						},
						(response, status) => {
								if (status === "OK") {
										directionsRenderer.setDirections(response);
								} else {
										
								}
						}
				);
		}
	}

	window.pay_now = async (jid, payment_status) => {
		Swal.fire({
			title: 'Pay Now?',
			buttonsStyling: true,
			confirmButtonClass: "button",
			confirmButtonText: 'OK',
			cancelButtonText: "Cancel",
			showCancelButton: true,
			icon: "success"
		}).then(async (e) => {
			if (e.isConfirmed) {
				const res = await doFetch(`${api_host}/api/job/update/status`, 'POST', {
					job_id: jid,
					action: 'charge',
					payment_status
				}, {
					Authorization: `${auth_type} ${auth_token}`,
					'DomainCode': domain_code,
					'Content-Type': 'application/json'
				});
				if (res.status) {
					toast_message(true, res.msg, 3000);
					init_data('jobs');
				} else {
					toast_message(false, res.msg || 'Failed updating job status', 3000);
				}
			}
		});
	};

	all_jobs_store.subscribe(value => {
		console.log(value);
		let _jobs = [];
		let lats = 0;
		let lngs = 0;

		for (let i = 0; i < value.length; i ++) {
			const job = value[i];
			let crews = '', hours = 0, notes = '';
			for (let j = 0; j < job.crews.length; j ++) {
				const crew = job.crews[j];
				// crews += `<a href='/#/User_Review?uid=${crew.id}' style='display: block;'>${crew.first_name} ${crew.last_name}</a>`;
				crews += `<div style='display: block;color: #40b3ff;'>${crew.first_name} ${crew.last_name}</div>`;
			}
			_jobs.push({
				"rn": crews ? crews : 'Not Assigned',
				"id": job.id,
				'hours': job.hours,
				'notes': job.notes,
				'name': job.client.first_name + ' ' + job.client.last_name,
				"cn": `<div>${job.client.first_name + ' ' + job.client.last_name}</div>`,
				"e": job.email,
				"hp": job.home_phone,
				"cp": job.mobile_phone,
				"a": `${job.address}, ${job.city}, ${(state_codes[job.state] || job.state)}`,
				"c": job.city,
				"dt": `${formatDate(job.service_date)} - ${job.time_preference}`,
				"lt": job.lawn,
				"st": job.service_type,
				"sf": job.service_frequency,
				"p": `${job.total_service_price}`,
				"total_service_price": `${job.total_service_price}`,
				"contractor_price": `${job.total_contractor_price}`,
				"total_contractor_price": `${job.total_contractor_price}`,
				"pt": job.paymethod,
				"s": get_job_status(job.status),
				"status": job.status,
				"co": formatDate(job.created_at),
				"date_filter": formatDate(job.service_date),
				"lat": job.lat,
				"lng": job.lng,
				"pay_now": (job.status !== 'charged' && formatDate(job.service_date) <= formatDate(new Date())) ? `<button class="pay_now_action" onclick="pay_now(${job.id}, ${!(job.statue === 'unpaid')})">Pay now</button>` : '',
				"map": `<input type="checkbox" class="map-checkbox" id="${job.id}" name="${job.id}" value="${job.id}" lat="${job.lat}" lng="${job.lng}" onchange="select_map(event)" />`,
			});
			lats += job.lat;
			lngs += job.lng;
		}
		_jobs.sort((a, b) => {
			if (new Date(a.date_filter) < new Date(b.date_filter)) return 1;
			if (new Date(a.date_filter) > new Date(b.date_filter)) return -1;
			return 0;
		});
		jobs = _jobs;

		center.lat = lats / jobs.length;
		center.lng = lngs / jobs.length;

		is_mounted = true;
	});

	$: {
		if (jobs.length > 0 && Object.keys(myself).length > 0) {
			let base_jobs = [];
			if (from_date && to_date) {
				base_jobs = jobs.filter(job => from_date <= job.date_filter && job.date_filter <= to_date);
			} else {
				base_jobs = jobs;
			}
			let total_prices = base_jobs.reduce((acc, job) => {
				if (myself.user.role === 'client') {
					return acc + parseFloat(job.total_service_price);
				} else {
					return acc + parseFloat(job.total_contractor_price);
				}
			}, 0);
			let total_hours = base_jobs.reduce((acc, job) => {
				return acc + job.hours;
			}, 0);
			statistic_data = {
				'id': 'statistic', 'e': '', 'hp': '', 'cp': '', 'a': '', 'c': '', 'dt': '', 'sf': '', 'lt': '', 'st': '', 's': '', 'pt': '', 'rn': '', 'map': `<a href='/' onclick="clear_map(event)">Clear Map</a>`, 'p': formatter.format(total_prices), 'contractor_price': formatter.format(total_prices), 'hours': numFormatter.format(total_hours)
			};
		}
	}

	let select_count = 0;

	let field_formats = {
			"p": (p) => {
					if (typeof(p) === "string" && !p.startsWith("$")) {
							return currency_formatter.format(parseFloat(p));
					} else {
							return p;
					}
			},
			"contractor_price": (p) => {
				if (typeof(p) === "string" && !p.startsWith("$")) {
					return currency_formatter.format(parseFloat(p));
				} else {
					return p;
				}
			}
	};

	let sort_functions = {
			"p": (el1, el2) => {
					let nameA = el1.toString().toUpperCase();
					let nameB = el2.toString().toUpperCase();
					if (nameA[0] === '$') {
							nameA = parseFloat(nameA.replace('$',''));
							nameB = parseFloat(nameB.replace('$',''));
					}
					if ((nameA < nameB || nameA === '-')) { return -1; }
					if ((nameA > nameB || nameB === '-')) { return 1; }
					return 0;
			},
			"dt": (el1, el2) => {
				let dateA = new Date(el1.split(' - ')[0]);
				let dateB = new Date(el2.split(' - ')[0]);
				if (dateA < dateB) { return -1; }
				if (dateA > dateB) { return 1; }
				return 0;
			},
	}

	// let action_items = [{"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": async (id) => { console.log(id); }}];
	let show_items = [
		{
			"id": "show",
			"i": "fas fa-eye",
			"s": "color: #1c54b2;",
			"f": (id) => { navigate(`/job_review/${id}`); },
			"l": "/job_review/<action_id>"
		},
	];
</script>


<Header />

<div class="formholder">
	<div class="pagetitle">
		{myself.user.role === 'client' ? 'Your Services' : 'Your Jobs'}
	</div>

	<Responsivetable
		field_formats={field_formats}
		field_styles={{}}
		statistic_data={(myself.user.role === 'contractor' && jobs.length > 0) ? statistic_data : undefined}
		sort_functions={sort_functions}
		num_per_page={100}
		date_filter_param='dt'
		selections_title = "Charge"
		show_date_range={true}
		action_items_title='Remove'
		selected_word='job'
		init_type='jobs'
		refresh_action='jobs'
		bind:from_date={from_date}
		bind:to_date={to_date}
		bind:table_header_config={table_header_config}
		bind:table_data={jobs}
		bind:select_count={select_count}
		bind:total_items={jobs.length}
		bind:show_items={show_items}
	/>

	{#if myself.user && (myself.user.role === 'contractor' || myself.user.role === 'employee')}
		<div
			id="map-canvas"
			class="relative w-full rounded h-600-px"
			data-lat="40.748817"
			data-lng="-73.985428"
			style="width: 100%;height: 500px;"
		></div>
	{/if}
</div>


<style>
	.formholder {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
	}
	@media (max-device-width: 1024px), (max-width: 1023px) {
		.formholder {
			width: 90%;
		}
	}
	.pagetitle {
		border-bottom: solid 1px #E9E9EC;
		font-size: 3rem;
		font-weight: bold;
	}
	:global(.pay_now_action) {
		background-color: #357a38;
		color: white;
		padding: 2px 5px;
		margin: 0px;
		width: auto;
	}
</style>